module.exports = __webpack_public_path__ + "static/DatBimIcon-2156bebafb202664b2f771fa4a50d4b7.png";